<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations sur le contrat</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.birthDate || originalMetadata?.birthDate"
      >
        <span class="card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.birthDate,
            }"
            >{{ metadata?.birthDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.birthDate &&
              originalMetadata?.birthDate !== metadata.birthDate
            "
            >{{ originalMetadata?.birthDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.startDate,
            }"
            >{{ metadata.startDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDate &&
              originalMetadata?.startDate !== metadata.startDate
            "
            >{{ originalMetadata.startDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.childrenCount != undefined ||
          originalMetadata?.childrenCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre d'enfants</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.childrenCount,
            }"
            >{{ metadata.childrenCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.childrenCount &&
              originalMetadata?.childrenCount !== metadata.childrenCount
            "
            >{{ originalMetadata.childrenCount }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.familyInsurance !== null &&
            metadata?.familyInsurance !== undefined) ||
          (originalMetadata?.familyInsurance !== null &&
            originalMetadata?.familyInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Assurance famille</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.familyInsurance === null ||
                  originalMetadata.familyInsurance === undefined ||
                  originalMetadata.familyInsurance !==
                    metadata.familyInsurance),
            }"
            >{{ getBooleanLabel(metadata.familyInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.familyInsurance !== null &&
              originalMetadata?.familyInsurance !== undefined &&
              originalMetadata?.familyInsurance !== metadata.familyInsurance
            "
            >{{ getBooleanLabel(originalMetadata.familyInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.adultsCount != undefined ||
          originalMetadata?.adultsCount != undefined
        "
      >
        <span class="card__label" i18n>Nombre d'adultes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.adultsCount,
            }"
            >{{ metadata.adultsCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.adultsCount &&
              originalMetadata?.adultsCount !== metadata.adultsCount
            "
            >{{ originalMetadata.adultsCount }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.contractKey">
        <span class="card__label" i18n>Contrat signé</span>
        <div class="d-flex gap-2 flex-column card__value">
          <app-file-icon
            height="20px"
            width="20px"
            (click)="viewFile(metadata.contractKey)"
            class="clickable"
          />
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    metadata?.buildings?.length! > 0 || originalMetadata?.buildings?.length! > 0
  "
>
  <div cardTitle i18n>Bâtiments</div>
  <div cardRows class="card__rows w-100">
    <div class="flex-basis-100">
      <div
        class="card__row"
        *ngFor="let building of metadata?.buildings; let i = index"
      >
        <ng-container
          *ngIf="
            building?.address || building.postalCode || building.appartmentCount
          "
        >
          <span class="card__label"
            ><ng-container i18n>Bâtiment</ng-container> {{ i + 1 }}</span
          >
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata?.buildings &&
                  (originalMetadata?.buildings?.length === 0 ||
                    !inBuildingsArray(building, originalMetadata?.buildings)),
              }"
            >
              <ng-container *ngIf="building.address"
                >{{ building.address }},
              </ng-container>
              <ng-container *ngIf="building.postalCode"
                >{{ building.postalCode }},
              </ng-container>
              <ng-container *ngIf="building.appartmentCount > 0"
                >{{ building.appartmentCount }}
                <ng-container i18n>appartement(s)</ng-container></ng-container
              >
            </span>
          </div>
        </ng-container>
      </div>
      <div
        class="card__row"
        *ngFor="let building of originalMetadata?.buildings; let i = index"
      >
        <span class="card__label"></span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            class="old-lead-value"
            *ngIf="
              metadata &&
              metadata?.buildings &&
              (metadata?.buildings?.length === 0 ||
                !inBuildingsArray(building, metadata?.buildings))
            "
          >
            <ng-container *ngIf="building.address"
              >{{ building.address }},
            </ng-container>
            <ng-container *ngIf="building.postalCode"
              >{{ building.postalCode }},
            </ng-container>
            <ng-container *ngIf="building.appartmentCount > 0"
              >{{ building.appartmentCount }}
              <ng-container i18n>appartements</ng-container></ng-container
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    metadata?.coInsured?.length! > 0 || originalMetadata?.coInsured?.length! > 0
  "
>
  <div cardTitle i18n>Co-assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="flex-basis-100">
      <div
        class="card__row"
        *ngFor="let coInsured of metadata?.coInsured; let i = index"
      >
        <ng-container
          *ngIf="
            coInsured.firstName ||
            coInsured.lastName ||
            coInsured.country ||
            coInsured.gender
          "
        >
          <span class="card__label"
            ><ng-container i18n>Co-assuré</ng-container> {{ i + 1 }}</span
          >
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata?.coInsured &&
                  (originalMetadata?.coInsured?.length! === 0 ||
                    !inCoinsurersArray(coInsured, originalMetadata?.coInsured)),
              }"
            >
              <ng-container
                >{{ coInsured.firstName }} {{ coInsured.lastName }},
              </ng-container>
              <ng-container *ngIf="coInsured.birthDate"
                >{{ coInsured.birthDate }},
              </ng-container>
              <ng-container *ngIf="coInsured.country"
                >{{
                  getCountryName(coInsured.country, languageCode)
                }},</ng-container
              >
              <ng-container *ngIf="coInsured.gender">{{
                getSexEnumLabel(coInsured.gender)
              }}</ng-container>
            </span>
          </div>
        </ng-container>
      </div>
      <div
        class="card__row"
        *ngFor="let coInsured of originalMetadata?.coInsured; let i = index"
      >
        <ng-container
          *ngIf="
            coInsured.firstName ||
            coInsured.lastName ||
            coInsured.country ||
            coInsured.gender
          "
        >
          <span class="card__label"></span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              class="old-lead-value"
              *ngIf="
                metadata &&
                metadata?.coInsured &&
                (metadata?.coInsured?.length === 0 ||
                  !inCoinsurersArray(coInsured, metadata?.coInsured))
              "
            >
              <ng-container
                >{{ coInsured.firstName }} {{ coInsured.lastName }},
              </ng-container>
              <ng-container *ngIf="coInsured.birthDate"
                >{{ coInsured.birthDate }},
              </ng-container>
              <ng-container *ngIf="coInsured.country"
                >{{
                  getCountryName(coInsured.country, languageCode)
                }},</ng-container
              >
              <ng-container *ngIf="coInsured.gender">{{
                getSexEnumLabel(coInsured.gender)
              }}</ng-container>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayAdditionalQuestions(metadata) ||
    displayAdditionalQuestions(originalMetadata)
  "
>
  <div cardTitle i18n>Questions supplémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.alreadyClient !== null &&
            metadata?.alreadyClient !== undefined) ||
          (originalMetadata?.alreadyClient !== null &&
            originalMetadata?.alreadyClient !== undefined)
        "
      >
        <span i18n class="card__label"
          >As-tu ou une personne assurée a-t-elle déjà été assurée en protection
          juridique au cours des trois dernières années et la police a-t-elle
          été résiliée par la société d'assurance ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.alreadyClient === null ||
                  originalMetadata.alreadyClient === undefined),
            }"
            >{{ getBooleanLabel(metadata.alreadyClient) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyClient &&
              originalMetadata?.alreadyClient !== metadata.alreadyClient
            "
            >{{ getBooleanLabel(originalMetadata.alreadyClient) }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.risk || originalMetadata?.risk">
        <span class="card__label" i18n>Pour quels risques </span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.risk,
            }"
            >{{ metadata?.risk }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.risk && originalMetadata?.risk !== metadata.risk
            "
            >{{ originalMetadata?.risk }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.company || originalMetadata?.company"
      >
        <span class="card__label" i18n>Auprès de quelle compagnie ?</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.company,
            }"
            >{{ metadata?.company }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.company &&
              originalMetadata?.company !== metadata.company
            "
            >{{ originalMetadata?.company }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.resiliation || originalMetadata?.resiliation"
      >
        <span class="card__label" i18n>Raisons de la résiliation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.resiliation,
            }"
            >{{ metadata?.resiliation }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.resiliation &&
              originalMetadata?.resiliation !== metadata.resiliation
            "
            >{{ originalMetadata?.resiliation }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.userInLitigation !== null &&
            metadata?.userInLitigation !== undefined) ||
          (originalMetadata?.userInLitigation !== null &&
            originalMetadata?.userInLitigation !== undefined)
        "
      >
        <span i18n class="card__label"
          >Une personne à assurer est-elle actuellement impliquée dans un litige
          ou l'a-t-elle été au cours des trois dernières années ou savez-vous
          qu'une personne à assurer le sera bientôt ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.userInLitigation === null ||
                  originalMetadata.userInLitigation === undefined),
            }"
            >{{ getBooleanLabel(metadata.userInLitigation) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.userInLitigation &&
              originalMetadata?.userInLitigation !== metadata.userInLitigation
            "
            >{{ getBooleanLabel(originalMetadata.userInLitigation) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-pdf-viewer-modal #pdfViewer />
